module.exports = __webpack_public_path__ + "img/monterey-front-angle.4daeddeb.png";